import React from "react";

/* eslint-disable max-len */
export default function CheckedIcon() {
    return (
        <svg id="レイヤー_1" data-name="レイヤー 1" viewBox="0 0 200 200">
            <defs>
                <style
                    dangerouslySetInnerHTML={{ __html: "\n      .cls-1{fill:#16ADC1;}\n    " }}
                />
            </defs>
            <path
                className="cls-1"
                d="M169.72,21.75H30.28a8.53,8.53,0,0,0-8.53,8.53V169.72a8.53,8.53,0,0,0,8.53,8.53H169.72a8.53,8.53,0,0,0,8.53-8.53V30.28A8.53,8.53,0,0,0,169.72,21.75ZM162.31,153.1a9.21,9.21,0,0,1-9.21,9.21H46.9a9.21,9.21,0,0,1-9.21-9.21V46.9a9.21,9.21,0,0,1,9.21-9.21H153.1a9.21,9.21,0,0,1,9.21,9.21Z"
            />
            <rect className="cls-1" x="51.72" y="51.72" width="96.57" height="96.57" rx="7.34" />
        </svg>
    );
}
